import { IExitForm } from '@/Models'
import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const bolReq = 'Field must be a boolean'
export const reqField = 'Field is required'

export const stepThreeSchema = yup.object().shape({
  problemsEncountered: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  enjoyedMost: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  enjoyedLeast: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  recommendEmployer: yup
    .boolean()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(bolReq),
  wouldReapply: yup
    .boolean()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(bolReq),
  recommendEmployerExplanation: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  exitInterviewConductedBy: yup
    .string()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  dateTime: yup.string().required(reqField),
})

export const StepThreeComp = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IExitForm>()

  return (
    <div className='container'>
      <div className='row justify-content-center p-3'>
        <div className='form-group row justify-content-center'>
          <div className='mb-3 text-start col-md-6 col-lg-5'>
            <label>Problems Encountered:</label>
            <textarea className='form-control' {...register('problemsEncountered')} />
            {errors.problemsEncountered && (
              <p className='text-danger'>{errors.problemsEncountered.message}</p>
            )}
          </div>
          <div className='text-start col-md-6 col-lg-5'>
            <label>Most Enjoyed thing about Tradegrid:</label>
            <textarea className='form-control' {...register('enjoyedMost')} />
            {errors.enjoyedMost && <p className='text-danger'>{errors.enjoyedMost.message}</p>}
          </div>
        </div>

        <div className='form-group row justify-content-center row-up'>
          <div className='mb-3 text-start col-md-6 col-lg-5'>
            <label>Least Enjoyed thing about Tradegrid:</label>
            <textarea className='form-control' {...register('enjoyedLeast')} />
            {errors.enjoyedLeast && <p className='text-danger'>{errors.enjoyedLeast.message}</p>}
          </div>

          <div className='text-start col-md-6 col-lg-5 exit-interview'>
            <label>Exit Interviewer:</label>
            <input
              type='text'
              className='form-control exit-input'
              {...register('exitInterviewConductedBy')}
            />
            {errors.exitInterviewConductedBy && (
              <p className='text-danger'>{errors.exitInterviewConductedBy.message}</p>
            )}
          </div>
        </div>

        <div className='form-group row justify-content-center row-up'>
          <div className='mb-3 text-start col-md-6 col-lg-5'>
            <label>Would you Recommend Us?</label>
            <select
              className='form-select'
              {...register('recommendEmployer', {
                setValueAs: (v) => {
                  if (v === true || v === false) return v
                  if (v === 'true') return true
                  if (v === 'false') return false
                  return undefined
                },
              })}
            >
              <option value=''>Select</option>
              <option value='true'>Yes</option>
              <option value='false'>No</option>
            </select>
            {errors.recommendEmployer && (
              <p className='text-danger'>{errors.recommendEmployer.message}</p>
            )}
          </div>

          <div className='text-start col-md-6 col-lg-5'>
            <label>Would you Reapply?</label>
            <select
              className='form-select'
              {...register('wouldReapply', {
                setValueAs: (v) => {
                  if (v === true || v === false) return v
                  if (v === 'true') return true
                  if (v === 'false') return false
                  return undefined
                },
              })}
            >
              <option value=''>Select</option>
              <option value='true'>Yes</option>
              <option value='false'>No</option>
            </select>
            {errors.wouldReapply && <p className='text-danger'>{errors.wouldReapply.message}</p>}
          </div>
        </div>

        <div className='form-group row justify-content-center row-up'>
          <div className='mb-3 text-start col-md-6 col-lg-5'>
            <label>Explanation (if No to any above):</label>
            <textarea className='form-control' {...register('recommendEmployerExplanation')} />
            {errors.recommendEmployerExplanation && (
              <p className='text-danger'>{errors.recommendEmployerExplanation.message}</p>
            )}
          </div>

          <div className='text-start col-md-6 col-lg-5'>
            <label>Interview Date/Time:</label>
            <input type='datetime-local' className='form-control' {...register('dateTime')} />
            {errors.dateTime && <p className='text-danger'>{errors.dateTime.message}</p>}
          </div>
        </div>
      </div>
    </div>
  )
}
